// Persists in-progress annotation/audit session time across page reloads,
// mirroring drafts.ts's localStorage pattern (same operator+episodeId
// scoping). Without this, reopening an in-progress episode resets the
// commit-time duration to "time since this last open" instead of the
// cumulative time actually spent — see docs discussion on
// total_annotate_duration_ms undercounting long episodes worked across
// multiple sessions.
const TIMER_PREFIX = 'secshot_session_timer_v1_';

function timerKey(
  operator: string | null | undefined,
  episodeId: string | null | undefined
): string | null {
  const name = (operator || '').trim();
  const episode = (episodeId || '').trim();
  if (!name || !episode) return null;
  return `${TIMER_PREFIX}${name}_${episode}`;
}

export function loadAccumulatedMs(
  operator: string | null | undefined,
  episodeId: string | null | undefined
): number {
  const key = timerKey(operator, episodeId);
  if (!key) return 0;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return 0;
    const n = Number(raw);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function flushAccumulatedMs(
  operator: string | null | undefined,
  episodeId: string | null | undefined,
  elapsedMs: number
): void {
  const key = timerKey(operator, episodeId);
  if (!key) return;
  try {
    localStorage.setItem(key, String(Math.max(0, Math.floor(elapsedMs))));
  } catch {
    // ignore write failures
  }
}

export function clearAccumulatedMs(
  operator: string | null | undefined,
  episodeId: string | null | undefined
): void {
  const key = timerKey(operator, episodeId);
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
